import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
export function Guarantee() {
  return <section className="bg-white py-20 sm:py-24" aria-labelledby="garantia-title" style={{
    paddingTop: "50px",
    paddingBottom: "50px"
  }} data-id="element-93" data-mp="1o2lsv5zg4o2z">
      <div className="mx-auto max-w-4xl px-6" data-id="element-94" data-mp="221bvt28y5hz9">
        <Reveal data-id="element-95" data-mp="1x421b86pag4k">
          <div className="rounded-3xl border border-mint-200 bg-mint-50 px-8 py-12 text-center sm:px-14" data-id="element-96" data-mp="1x5mv2vl6xv1d">
            <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-mint-600 text-white" data-id="element-97" data-mp="19fadet058jxl">
              <ShieldCheckIcon className="h-7 w-7" aria-hidden="true" data-id="element-98" data-mp="14dl35fkqwaak" />
            </span>
            <h2 id="garantia-title" className="mt-6 font-display text-3xl text-ink sm:text-4xl" data-id="element-99" data-mp="1j5vcehjqbqh1">
              Garantía de 7 días
            </h2>
            <p className="mx-auto mt-5 max-w-xl text-lg leading-relaxed text-ink-soft" data-id="element-100" data-mp="qnpy2sp0u824">
              Abrís los 6 tomos. Revisás los 6 bonos. Los usás en tu vida si
              querés. Si en 7 días no es lo que esperabas,{' '}
              <strong className="font-semibold text-ink" data-id="element-101" data-mp="oyqfacyku3l9">
                te devolvemos el 100%
              </strong>
              .
            </p>
            <p className="mt-4 font-display text-2xl text-mint-700" data-id="element-102" data-mp="ypb81jrkkdw9">
              Sin preguntas. Sin formularios. Sin drama.
            </p>
            <p className="mx-auto mt-6 max-w-lg text-[15px] leading-relaxed text-ink-muted" data-id="element-103" data-mp="12pv8oxbcpzn5">
              Desde Madrid hasta Bogotá. Desde México hasta Buenos Aires. Desde
              Lima hasta Caracas. El mismo compromiso para todos.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}